import { useState, useEffect } from 'react';

export const useCharacterCounter = (value, isEditing, ref) => {
  const [charCount, setCharCount] = useState(value ? value.length : 0);

  useEffect(() => {
    setCharCount(value ? value.length : 0);
  }, [value]);

  useEffect(() => {
    if (isEditing && ref.current) {
      const handleInput = () => {
        if (ref.current) {
          setCharCount(ref.current.innerText.length);
        }
      };
      const element = ref.current;
      element.addEventListener('input', handleInput);
      
      handleInput(); // Initial count

      return () => {
        if (element) {
          element.removeEventListener('input', handleInput);
        }
      };
    }
  }, [isEditing, ref]);

  return charCount;
};
